import {TranslateService} from '@ngx-translate/core';
import {Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter, Renderer2} from '@angular/core';

import {FileIconService} from '@app/services/net-remit/file-icon.service';
import {MessageService as PrimeMessageService} from 'primeng/api';

import {MemoPaymentView} from '@app/shared/views/MemoPaymentView';
import {ErrorView} from '@app/shared/models/ErrorView';

import {fadeIn} from 'assets/animations/animations';
import {default as constantsFile} from '@app/shared/constants.json';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'app-payment-single-form',
  templateUrl: './payment-single-form.component.html',
  styleUrls: ['./payment-single-form.component.scss'],
  animations: [fadeIn],
  standalone: false
})
export class PaymentSingleFormComponent implements OnInit {

  // Variable de control
  alive: boolean;
  acceptedFileExtensions: Array<string> = new Array<string>('.txt', '.csv');

  constants: any = constantsFile.constants;

  helpMessage: string = 'MemoPayments.Incorrect Memo Content Format';
  tooltipMessage: string = 'MemoPayments.Memo Content';

  // Variables
  showText: boolean;
  showFile: boolean;
  showHelpMessage: boolean;

  // Valores de constantes
  manualCaptureBspConst: string = this.constants.memoContentOrigin.manualCaptureBsp;
  manualCaptureArcConst: string = this.constants.memoContentOrigin.manualCaptureArc;
  patternMemoContent: any = this.constants.pattern.memoContent;

  // Errores
  fileError: ErrorView = null;

  @Input() payment: MemoPaymentView;
  @Input() memoContentOriginSelected: string;
  @Input() fileInput: File;
  @Input() paymentSavedOk: boolean;

  @Output() attachmentFileMethod = new EventEmitter<{ file: FileList, toRemove: boolean }>();

  @ViewChild('fileupload') inputFile: ElementRef;
  @ViewChild('helpButton', {static: true}) helpButton: ElementRef;
  @ViewChild('tooltip', {static: true}) tooltip: Tooltip;

  constructor(
    private fileIconService: FileIconService,
    private primeMessageService: PrimeMessageService,
    private translateService: TranslateService,
    private renderer: Renderer2
  ) {
  }

  ngOnInit(): void {
    this.translateService.get('MemoPayments.Memo Content').subscribe((translatedText: string) => {
      this.tooltipMessage = translatedText;
    });
  }

  ngOnChanges() {
    this.showText = (this.memoContentOriginSelected === this.manualCaptureBspConst || this.memoContentOriginSelected === this.manualCaptureArcConst);
    this.showFile = (this.memoContentOriginSelected === this.manualCaptureBspConst || this.memoContentOriginSelected === this.manualCaptureArcConst);
  }

  public onFileChange(event: any) {
    if (event.files.length > 0) {
      this.attachmentFileMethod.emit({file: event.files[0], toRemove: false});
      this.fileInput = event.files[0];
      const fileFormat = this.fileInput.name.slice(Math.max(0, this.fileInput.name.lastIndexOf('.')) || Infinity);
      const index = this.acceptedFileExtensions.indexOf(fileFormat.toLowerCase());
      const isWhiteListOk = (index > -1);

      if (isWhiteListOk && this.fileInput.size > 0) {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          let content = '';
          for (const line of (fileReader.result as string).split(/[\r\n]+/)) {
            if (line != '') {
              content += (content != '') ? '\n' + line : line;
            }
          }

          if (RegExp(this.patternMemoContent).test(content)) { //Validate it is a correct content before setting
            this.payment.memoContent = content;
          } else {
            this.fileInput = null;
            this.primeMessageService.add({
              closable: true,
              severity: 'error',
              summary: this.translateService.instant('Modal.Error'),
              detail: this.translateService.instant('MemoPayments.Enter Memo Content'),
              key:'toast-payment-form',
            });
          }
        };
        fileReader.readAsText(this.fileInput);
      } else {
        this.payment.memoContent = undefined;
        const errorDescription = (!isWhiteListOk) ? 'Selected File Not Allowed' : 'Selected File Is Empty';
        this.fileError = new ErrorView(errorDescription, '', '');
      }
    }
  }

  public getFileIcon(fileName: string) {
    return this.fileIconService.getFileIcon(fileName);
  }

  // Si se elimina el fichero, se vuelve a permitir la introducción de memocontent por texto
  public removeFile() {
    this.fileError = this.fileInput = null;
    this.payment.memoContent = undefined;
  }
}
